import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*默认密码 123456", -1)
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_VEselect = _resolveComponent("VEselect")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.addOrEditDialog,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addOrEditDialog) = $event)),
    "custom-class": "FormDialogBox",
    width: "700px",
    title: _ctx.addOrEditTypeTitle[_ctx.addOrEditType],
    "close-on-press-escape": false,
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addOrEditCancel()))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addOrEditDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: _ctx.determineBtnLoading,
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addOrEditDetermine()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.addOrEditTypeTitle[_ctx.addOrEditType]), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "addForm",
        model: _ctx.addOrEditForm,
        rules: _ctx.addOrEditRules,
        ref: "addOrEditFormRef",
        "label-width": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addOrEditForm.username) = $event)),
                placeholder: "请输入名称",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.mobile,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addOrEditForm.mobile) = $event)),
                placeholder: "请输入手机号码",
                clearable: "",
                maxlength: "11"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "role_id"
          }, {
            default: _withCtx(() => [
              (_ctx.addOrEditDialog)
                ? (_openBlock(), _createBlock(_component_VEselect, {
                    key: 0,
                    selectValue: _ctx.addOrEditForm.role_id,
                    "onUpdate:selectValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addOrEditForm.role_id) = $event)),
                    apiUrl: ['role', 'getList'],
                    placeholder: "请选择角色",
                    queryName: "name",
                    objLabel: "name",
                    objKey: "id",
                    selectedObj: _ctx.addOrEditForm.roleSelectedObj
                  }, null, 8, ["selectValue", "selectedObj"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "岗位",
            prop: "position_id"
          }, {
            default: _withCtx(() => [
              (_ctx.addOrEditDialog)
                ? (_openBlock(), _createBlock(_component_VEselect, {
                    key: 0,
                    selectValue: _ctx.addOrEditForm.position_id,
                    "onUpdate:selectValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addOrEditForm.position_id) = $event)),
                    apiUrl: ['jobs', 'getList'],
                    placeholder: "请选择岗位",
                    queryName: "name",
                    objLabel: "name",
                    objKey: "id",
                    selectedObj: _ctx.addOrEditForm.positionSelectedObj
                  }, null, 8, ["selectValue", "selectedObj"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "头像",
            prop: "avatar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ImageUpload, {
                url: _ctx.addOrEditForm.avatar,
                "onUpdate:url": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addOrEditForm.avatar) = $event)),
                width: 150,
                height: 150,
                notip: ""
              }, null, 8, ["url"])
            ]),
            _: 1
          }),
          _hoisted_1
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}